/// /////////////////////////////////////////////////////////////////////////////////////
///                           Copyright (c) 2020 - 2020
///                            Coyote Logistics L.L.C.
///                          All Rights Reserved Worldwide
///
/// WARNING:  This program (or document) is unpublished, proprietary
/// property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
/// Unauthorized reproduction, distribution or disclosure of this program
/// (or document), or any program (or document) derived from it is
/// prohibited by State and Federal law, and by local law outside of the U.S.
/// //////////////////////////////////////////////////////////////////////////////////////

import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";
import { resetBuildAdhoc } from "../../slices/adHocSlice";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";

import BuildAdHocModal from "./BuildAdHocModal";
import styled from "styled-components";

const StyledButton = styled(({ theme, ...otherProps }) => (
  <Button {...otherProps} />
))`
  margin-left: ${(props) => props.theme.spacing(3)}px!important;
`;

const BuildAdHocButton = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  const setModalOpen = () => setOpen(true);
  const setModalClosed = () => {
    setOpen(false);
    dispatch(resetBuildAdhoc());
  };
  return (
    <>
      <StyledButton
        onClick={setModalOpen}
        theme={theme}
        variant="contained"
        data-testid="adhoc-button"
      >
        Build Ad Hoc
      </StyledButton>
      <BuildAdHocModal open={open} handleClose={setModalClosed} />
    </>
  );
};

export default BuildAdHocButton;
